import applyEmojiFont from './applyEmojiFont';
import getEmoji from './getEmoji';
import getEmojiCodePointWithSkinTone from './getEmojiCodePointWithSkinTone';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';

export default function createEmojiNode(emojiKey: string): HTMLElement {
    const emojiToInsert = getEmoji(emojiKey);
    if (emojiToInsert) {
        const emojiNode = document.createElement('span') as HTMLAnchorElement;
        emojiNode.id = emojiToInsert.codePoint;
        emojiNode.innerText = getEmojiCodePointWithSkinTone(emojiToInsert);

        if (isBrowserIE()) {
            // In IE, emoji is inserted in black and white by default (VSO 42674)
            applyEmojiFont(emojiNode);
        }

        return emojiNode;
    }

    return null;
}
